/**
 * Every OPFS path in the app is built here so that a rename never leaves orphaned bytes
 * behind. Ids are opaque strings; they never contain a separator.
 */

const PROJECTS = "projects";
const EXPORTS = "exports";

export const projectDir = (projectId: string): string => `${PROJECTS}/${projectId}`;

export const sourceDir = (projectId: string, sourceId: string): string =>
  `${projectDir(projectId)}/sources/${sourceId}`;

export const originalPath = (projectId: string, sourceId: string): string =>
  `${sourceDir(projectId, sourceId)}/original.bin`;

export const proxyPath = (projectId: string, sourceId: string): string =>
  `${sourceDir(projectId, sourceId)}/proxy.mp4`;

/**
 * The working PCM, 16-bit. The extension is part of the contract: a project imported
 * before the switch from Float32 still has `audio.f32`, and reading those bytes as 16-bit
 * would silently produce noise at twice the length.
 */
export const pcmPath = (projectId: string, sourceId: string): string =>
  `${sourceDir(projectId, sourceId)}/audio.i16`;

/** Written by builds before the 16-bit switch; read as Float32 when it is all there is. */
export const legacyPcmPath = (projectId: string, sourceId: string): string =>
  `${sourceDir(projectId, sourceId)}/audio.f32`;

export const peaksPath = (projectId: string, sourceId: string): string =>
  `${sourceDir(projectId, sourceId)}/peaks.bin`;

export const thumbnailsPath = (projectId: string, sourceId: string): string =>
  `${sourceDir(projectId, sourceId)}/thumbnails.webp`;

/** A single small still that stands for the project in the file list. */
export const posterPath = (projectId: string, sourceId: string): string =>
  `${sourceDir(projectId, sourceId)}/poster.webp`;

export const exportPath = (exportId: string, fileName: string): string =>
  `${EXPORTS}/${exportId}/${fileName}`;
